import http from '../../../services/api'
import type { APIPaginatedResponse } from '../../../services/types'

const apiPath = import.meta.env.VITE_API_PATH

export type ItemMergeItemRef = {
  uuid: string | null
  name: string | null
}

export type ItemMergeUserRef = {
  uuid: string | null
  name: string | null
}

export type ItemMergeApi = {
  uuid: string
  status: string | null
  reason: string | null
  target_item?: ItemMergeItemRef | null
  source_items?: ItemMergeItemRef[]
  merged_by?: ItemMergeUserRef | null
  completed_at: string | null
  created_at: string | null
  updated_at: string | null
}

export type MergeItemsPayload = {
  source_item_ids: string[]
  reason?: string | null
}

async function mergeItems(targetItemUuid: string, payload: MergeItemsPayload) {
  return await http.post<{ data: ItemMergeApi }>(`${apiPath}items/item-merges/${targetItemUuid}/merge`, payload, {
    errorHandle: false,
  } as any)
}

export type ListItemMergesParams = {
  perPage?: number
  page?: number
  search?: string
  startDate?: string | null
  endDate?: string | null
}

async function listItemMerges(options: ListItemMergesParams = {}) {
  const params = new URLSearchParams({
    per_page: String(options.perPage ?? 25),
    page: String(options.page ?? 1),
  })
  const trimmed = (options.search ?? '').trim()
  if (trimmed) {
    params.set('search', trimmed)
  }
  if (options.startDate) {
    params.set('start_date', options.startDate)
  }
  if (options.endDate) {
    params.set('end_date', options.endDate)
  }

  return await http.get<APIPaginatedResponse<ItemMergeApi>>(`${apiPath}items/item-merges?${params.toString()}`)
}

async function getItemMerge(mergeUuid: string) {
  return await http.get<{ data: ItemMergeApi }>(`${apiPath}items/item-merges/${mergeUuid}`)
}

async function getItemMergeHistory(itemUuid: string) {
  return await http.get<{ data: ItemMergeApi[] }>(`${apiPath}items/item-merges/${itemUuid}/merge-history`)
}

const itemMergesService = {
  mergeItems,
  listItemMerges,
  getItemMerge,
  getItemMergeHistory,
}

export default itemMergesService
